export type ClassValue = string | false | null | undefined;

/** Sloučí podmíněné třídy bez externí závislosti (clsx/ tailwind-merge nejsou potřeba). */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
